import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-jodo-popup',
  templateUrl: './jodo-popup.component.html',
  styleUrls: ['./jodo-popup.component.css']
})
export class JodoPopupComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,private dialogRef: MatDialogRef<JodoPopupComponent>,private router: Router) { }

  ngOnInit(): void {
    console.log(this.data);
  }

  onClose(direction){
    this.router.navigate([direction]);
    this.dialogRef.close();
  }

  purchaseAgain(){
    this.dialogRef.close('purchase');
  }

  explorePackages(){
    this.dialogRef.close();
    this.router.navigate(['/subscription/subscriptionPackages']);
  }

  Close(){
    this.dialogRef.close();
  }

}
